module.exports = __webpack_public_path__ + "assets/img/29_287.356c965d.jpg";